/**
 * Prefix an internal href with /bg when the page is Bulgarian.
 *
 * Internal links across the site are written unprefixed ("/services/…").
 * On a /bg/ page they must point at the /bg/ URL, otherwise the click lands on
 * the English page and proxy.ts has to bounce it back with a redirect (which
 * also forces a full page load instead of a client-side navigation).
 *
 * Left untouched: external URLs, protocol links (mailto:, tel:), hash-only
 * links, paths already under /bg, API routes and file-like paths (/feed.xml).
 */
export function localizeHref(href: string, lang: "en" | "bg"): string {
  if (lang !== "bg") return href;
  if (!href.startsWith("/") || href.startsWith("//")) return href;

  const cut = href.search(/[?#]/);
  const path = cut === -1 ? href : href.slice(0, cut);
  const rest = cut === -1 ? "" : href.slice(cut);

  if (path === "/bg" || path.startsWith("/bg/")) return href;
  if (path.startsWith("/api/") || path === "/api") return href;
  if (/\/[^/]+\.[a-z0-9]+$/i.test(path)) return href;

  return (path === "/" ? "/bg/" : `/bg${path}`) + rest;
}
